function GameJam() {
    return (<div>
        In October, Bristol Computer Science Society hosted their annual game jam. As a break from studying, me and my friends decided to compete. The theme was "Contamination" so we decided to make a small 2-player networked game. The objective was to upgrade your virus so that it could infect all agents moving around the map. We networked so that when an agent left player one's screen, it would appear on player two's screen. We ended up winning the "Most Technical" category and learnt why people don't usually make networked games in a game jam!
    </div>);
}

export default GameJam;